import DashboardDefault from 'views/dashboard/Default';

import MainLayout from 'layout/MainLayout';
import SerialsList from 'views/serials';
import Auth from 'ui-component/Auth';
import Contacts from 'views/contacts';
import ContactForm from 'views/contacts/ContactForm';
import ContactsApprove from 'views/contacts/contactsApprove';
import ContactDetails from 'views/contacts/ContactDetails';


// Testings
import TestPage from 'views/testpage';
import { element } from 'prop-types';


// Users
import UsersList from 'views/users'

// Events
import EventsList from 'views/events'

// Locations
import Locations from 'views/locations'

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const MainRoutes = {
	path: '/',
	element: <MainLayout />,
	children: [
		{
			path: 'contacts',
			children: [
				{
					path: '',
					element: (
						<Auth requiredPermissions={['List Contact (Page)']}>
							<Contacts />
						</Auth>
					)
				},
				{
					path: 'create',
					element: (
						<Auth requiredPermissions={['Create Contact (Page)']}>
							<ContactForm />
						</Auth>
					)
				},
				{
					path: 'portal',
					element: <ContactsApprove />
				},

				{
					path: ':id',
					element: (
						<Auth requiredPermissions={['View Contact Details (Page)']}>
							<ContactDetails />
						</Auth>
					)
				},
				{
					path: 'edit/:id',
					element: (
						<Auth requiredPermissions={['Edit Contact (Page)']}>
							<ContactForm edit />
						</Auth>
					)
				}
			]
		},

		{
			path: '*',
			element: (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						zIndex: 99999,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100dvh',
						width: '100vw',
						background: '#f9f9f9',
						flexDirection: 'column',
						gap: '0px'
					}}
				>
					<h1>404</h1>
					<h6>Page Not Found</h6>
				</div>
			)
		},
		{
			path: 'serials',
			children: [
				{
					path: '',
					element: (
						// <Auth>
							<SerialsList />
						// </Auth>
					)
				},
			]
		},
		{
		path: 'users',
			children: [
				{
					path: '',
					element: (
						// <Auth>
							<UsersList />
						// </Auth>
					)
				},
			]
		},
		{
		path: 'events',
			children: [
				{
					path: '',
					element: (
						// <Auth>
							<EventsList />
						// </Auth>
					)
				},
			]
		},
		{
		path: 'locations',
			children: [
				{
					path: '',
					element: (
						// <Auth>
							<Locations />
						// </Auth>
					)
				},
			]
		},
		// {
		// 	path: 'warehouses',
		// 	children: [
		// 		{
		// 			path: '',
		// 			element: (
		// 				<Auth requiredPermissions={['List Warehouse (Page)']}>
		// 					<Warehouses />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: ':id',
		// 			element: (
		// 				<Auth requiredPermissions={['View Warehouse Details (Page)']}>
		// 					<WarehouseDetails />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'create',
		// 			element: (
		// 				<Auth requiredPermissions={['Create Warehouse (Page)']}>
		// 					<WarehouseForm />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'edit/:id',
		// 			element: (
		// 				<Auth requiredPermissions={['Update Warehouse (Page)']}>
		// 					<WarehouseForm edit />
		// 				</Auth>
		// 			)
		// 		}
		// 	]
		// },
		// {
		// 	path: 'returns',
		// 	children: [
		// 		{
		// 			path: '',
		// 			element: (
		// 				<Auth requiredPermissions={['List Returns (Page)']}>
		// 					<Returns />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'create',
		// 			element: (
		// 				<Auth requiredPermissions={['Create Returns (Page)']}>
		// 					<ReturnsDetails />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: ':id',
		// 			element: (
		// 				<Auth requiredPermissions={['View Returns Details (Page)']}>
		// 					<ReturnsDetails edit />
		// 				</Auth>
		// 			)
		// 		}
		// 	]
		// },

		// {
		// 	path: 'products',
		// 	children: [
		// 		{
		// 			path: '',
		// 			element: (
		// 				<Auth requiredPermissions={['List Model (Page)']}>
		// 					<ProductsList />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'inactive',
		// 			element: (
		// 				<Auth requiredPermissions={['List Model (Page)']}>
		// 					<ProductsList />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: ':id',
		// 			element: (
		// 				<Auth requiredPermissions={['View Model Details (Page)']}>
		// 					<ProductView />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'create',
		// 			element: (
		// 				<Auth requiredPermissions={['Create Model (Page)']}>
		// 					<ProductForm />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'edit/:id',
		// 			element: (
		// 				<Auth requiredPermissions={['Update Warehouse (Page)']}>
		// 					<ProductForm edit />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'export',
		// 			element: (
		// 				<Auth requiredPermissions={['List Model (Page)']}>
		// 					<ExportProduct />
		// 				</Auth>
		// 			)
		// 		},
		// 		{
		// 			path: 'import',
		// 			element: (
		// 				<Auth requiredPermissions={['List Model (Page)']}>
		// 					<ImportProduct />
		// 				</Auth>
		// 			)
		// 		}
		// 	]
		// },
		{
			path: 'test',
			children: [
				{
					path: '',
					element: (
						<Auth>
							<TestPage />
						</Auth>
					)
				}
			]
		},
	]
};

export default MainRoutes;

